angular.module('impactx.changeauthorization').controller('ChangeAuthorizationCtrl', [
    '$scope',
    '$context',
    'dataGen',
    'ProductViewService',
    'ThemeWorldService',
    'LoginService',
    '$securityManager',
    'ToastService',
    'TranslationService',
    ChangeAuthorizationCtrl]);

function ChangeAuthorizationCtrl($scope, $context, dataGen, ProductViewService, ThemeWorldService, LoginService, $securityManager, ToastService, TranslationService) {
    let self = this;
    $scope.companyControl = {};

    dataGen.getData($scope, {}, "/authorization/view").then(function () {
        $scope.userInfo = $context.user;
        $scope.userInfo.imageUrl = $context.userImageUrl;
        $scope.userInfo.companyName = $context.company.value;
    });

    self.updateCompanyPopup = function (selected) {
        if (impactX.isDefined(selected, "id")) {
            $scope.data.companies.selected = null;
        }
        $scope.companyControl.getEntries($scope.updateCompanyProperties, true);
    };

    self.changeAuthorization = function (selectedAuthorization, selectedCompany) {
        var selectedAuthorizationId = impactX.isDefined(selectedAuthorization, "id");
        var selectedCompanyId = impactX.isDefined(selectedCompany, "id");

        if (selectedAuthorizationId) {
            ProductViewService.deactivateActiveProductView().then(function () {
                ThemeWorldService.deactivateActiveThemeWorld().then(function () {
                    ThemeWorldService.deactivateActiveThemeWorldSearch(true).then(function () {
                        dataGen.postAsForm({}, {
                            authId: selectedAuthorizationId,
                            comId: selectedCompanyId ? selectedCompanyId : undefined
                        }, "/authorization/change").then(function () {
                            $securityManager.invalidateProcesses();
                            LoginService.refreshUI(true);
                            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
                        });
                    });
                });
            });
        }
    };

    $scope.$watch('data.authorizations.selected', function (newValue, oldValue) {
        if (newValue && !angular.equals(newValue, oldValue)) {
            $scope.updateCompanyProperties = [{field: "authId", value: newValue.id}];
        }
    });
}